import * as React from 'react';
import './ruleCard.scss';

interface IRuleCardProps {
    mainContent: React.ReactNode;
    footerContent: React.ReactNode;
    className?: string;
}

export class RuleCard extends React.Component<IRuleCardProps> {
    render(): React.ReactNode {
        const { mainContent, footerContent, className } = this.props;

        return (
            <div className={`nomst-rule-card ${className}`}>
                <div className="nomst-rule-card__content">
                    {mainContent}
                </div>
                <div className="nomst-rule-card__footer">
                    {footerContent}
                </div>
            </div>
        );
    }
}

export default { RuleCard };